import axios from 'axios';
import { apiErrorToStr } from '../utils';
import { setToken, getToken, setJwtHeaders, resetToken } from '../utils/auth';

const api = '/api/v1/auth/client';
const AUTH = 'auth/auth';
const AUTH_PENDING = `${AUTH}_PENDING`;
const AUTH_FULFILLED = `${AUTH}_FULFILLED`;
const AUTH_REJECTED = `${AUTH}_REJECTED`;
const LOGOUT = 'auth/logout';

let token = getToken();
const initialState = {
  isLoading: Boolean(token),
  user: null,
  error: null,
};

export const getProfile = () => (dispatch) => {
  if (token) {
    setJwtHeaders();
    dispatch({ type: AUTH, payload: axios.get(api) });
  }
};

export const login = data => async (dispatch) => {
  try {
    dispatch({ type: AUTH_PENDING });
    const res = await axios.post(`${api}/login`, data);
    // eslint-disable-next-line prefer-destructuring
    token = res.data.data.token;
    setToken(token);

    dispatch(getProfile());
  } catch (e) {
    dispatch({ type: AUTH_REJECTED, payload: e });
  }
};

export const logout = () => {
  resetToken();
  return { type: LOGOUT };
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case AUTH_PENDING:
      return { ...state, isLoading: true };

    case AUTH_FULFILLED:
      return { ...state, isLoading: false, user: payload.data.data };

    case AUTH_REJECTED: {
      const error = apiErrorToStr(payload.response);
      return { isLoading: false, user: null, error };
    }

    case LOGOUT:
      return { isLoading: false, user: null, error: null };

    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/modules/auth.js